import React, { useEffect, useState, useRef } from "react";
import icon from "../../assets/images/map-marker-svgrepo-com.svg";
import io from "socket.io-client";
import { useSelector } from "react-redux";

const serverUrl = process.env.REACT_APP_SERVER_URL;

// const socket = io(serverUrl, {
//   query: {
//     app_key: "VURA_9Lrrq9xoYI",
//     secret_key: "44BDE3F4213647FE6DBD353A5DF56",
//   },
// });

function GetLocations() {
  const { isClockIn, latitude, longitude } = useSelector(
    (state) => state.location
  );
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const [token, setToken] = useState("");
  const [locations, setLocations] = useState([]);
  const mapRef = useRef(null);
  const polylineRef = useRef(null);

  // useEffect(() => {
  //   if (token === "") {
  //     socket.on("token", (token_data) => {
  //       console.log("location token", token_data);
  //       // sessionStorage.setItem("chatAuth", token_data);
  //       setToken(token_data);
  //     });
  //   }
  // }, [token]);

  // socket.on("error", (error_data) => {
  //   console.log("error_data");
  //   console.log(error_data);
  // });

  useEffect(() => {
    if (isClockIn) {
      console.log("Clocked In - Start tracking");
      console.log("Initial Location:", latitude, longitude);
    }
  }, [isClockIn]);
  //   const sendLocationToSocket = (latitude, longitude) => {
  //     socket.emit("send_location", { latitude, longitude });
  //   };

  useEffect(() => {
    if (isClockIn) {
      if ("geolocation" in navigator) {
        let watchId;
        let previousLocation = null;

        const updateLocation = (position) => {
          const { latitude, longitude } = position.coords;
          const newLocation = { latitude, longitude };

          const distance = previousLocation
            ? calculateDistance(previousLocation, newLocation)
            : Infinity;
          const threshold = 0.0001; //  0.0001 for may be 10 meter

          if (distance > threshold || !previousLocation) {
            const locationData = {
              userId: userProfile?.employeeId,
              lat: latitude,
              lng: longitude,
            };

            let message = JSON.stringify(locationData);
            console.log(message);
            // socket.emit("chatMessage", { token, message });
            console.log("first");
          }
        };

        const handleError = (error) => console.error("Location error:", error);

        const options = {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 10000, // Timeout if no location is received within 10 seconds
        };

        watchId = navigator.geolocation.watchPosition(
          updateLocation,
          handleError,
          options
        );

        return () => {
          if (watchId) {
            navigator.geolocation.clearWatch(watchId);
          }
        };
      } else {
        console.error("Geolocation not supported");
      }
    }
  }, [isClockIn]);

  const calculateDistance = (loc1, loc2) => {
    const R = 6371;
    const dLat = deg2rad(loc2.latitude - loc1.latitude);
    const dLon = deg2rad(loc2.longitude - loc1.longitude);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(loc1.latitude)) *
        Math.cos(deg2rad(loc2.latitude)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  return <></>;
}

export default GetLocations;
